export function flattenTree(list, options = {}) {
    const { childrenKey = 'children' } = options
    const result = []
    function flatten(_list = []) {
        for (const item of _list) {
            result.push(item)
            flatten(item[childrenKey])
        }
    }
    flatten(list || [])
    return result
}

const rootSymbol = Symbol()
export function array2Tree(data, options = {}) {
    const childrenMap = new Map()

    const idKey = options.idKey || 'id'
    const rootId = options.rootId ?? rootSymbol
    const parentKey = options.parentKey || 'parentId'
    const childrenKey = options.childrenKey || 'children'

    for (const it of data) {
        const key = it[parentKey] ?? rootId
        let array = childrenMap.get(key)
        if (!array) {
            array = []
            childrenMap.set(key, array)
        }

        array.push(it)
    }

    const roots = childrenMap.get(rootId)

    const childIds = new Set()
    for (const array of childrenMap.values()) {
        if (options.sortKey) {
            array.sort((it1, it2) => {
                return it1[options.sortKey] - it2[options.sortKey]
            })
        }

        for (const it of array) {
            it[childrenKey] = childrenMap.get(it[idKey])
            if (!roots) {
                childIds.add(it[idKey])
            }
        }
    }

    if (roots) {
        return roots
    }

    const rootIds = [...childrenMap.keys()].filter((pId) => childIds.has(pId))

    return rootIds.map((it) => ({
        [idKey]: it,
        [childrenKey]: childrenMap.get(it),
    }))
}

export function walkTree(data, each, options = {}) {
    const walk = options.async ? _asyncWalkTree : _walkTree
    return walk(data, each, options)
}

function _walkTree(data, each, options = {}, parent) {
    const { childrenKey = 'children', parentPaths = false } = options
    parent = parent ?? (parentPaths ? [] : undefined)
    for (const [index, item] of data.entries()) {
        const children = item[childrenKey] || []

        let returnValue = each(item, index, parent, children)

        if (returnValue === false) {
            return returnValue
        }

        if (Array.isArray(children)) {
            returnValue = _walkTree(children, each, options, parentPaths ? [...parent, item] : item)
            if (returnValue === false) {
                return returnValue
            }
        }
    }

    return true
}

async function _asyncWalkTree(data, each, options = {}, parent) {
    const { childrenKey = 'children', parentPaths = false } = options
    parent = parent ?? (parentPaths ? [] : undefined)
    for (const [index, item] of data.entries()) {
        const children = item[childrenKey] || []

        let returnValue = each(item, index, parent, children)

        if (returnValue && returnValue instanceof Promise) {
            returnValue = await returnValue
        }

        if (returnValue === false) {
            return returnValue
        }

        if (Array.isArray(children)) {
            returnValue = await _asyncWalkTree(children, each, options, parentPaths ? [...parent, item] : item)
            if (returnValue === false) {
                return returnValue
            }
        }
    }

    return true
}
